export default __webpack_public_path__ + "static/media/landing.e5825316.mp4";